// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperCard = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    position: relative;
    background-color: ${isDark ? theme.colors.base.main : theme.colors.white};
  `,
);
